module.exports = __webpack_public_path__ + "static/media/proj7_img1.a5ff122a.jpg";